import { OnInit } from '@angular/core';
import { ImageUtils } from '../utils/image/image-utils';
import { LanguageService } from '../../services/language/language.service';
import { QrCodeTypeEnum } from '../../enums/streaming-bundles/qr-code-type.enum';
var QrTileComponent = /** @class */ (function () {
    function QrTileComponent(languageService) {
        this.languageService = languageService;
    }
    QrTileComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(QrTileComponent.prototype, "QRCodeImgUrl", {
        get: function () {
            var language = this.languageService.getCurrentLanguage().toLowerCase();
            return ImageUtils.getQrCodeImageUrl(this.QRCodeType, language);
        },
        enumerable: true,
        configurable: true
    });
    return QrTileComponent;
}());
export { QrTileComponent };
